import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";


function KitchenPerformanceReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },

    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Order Number",
      accessorKey: "Order Number",
    },
    {
      header: "Type",
      accessorKey: "Type",
    },
    {
      header: "Order Time",
      accessorKey: "Order Time",
    },
    {
      header: "Cooking Start Time",
      accessorKey: "Cooking Start Time  ",
    },
    {
      header: "Cooking End Time",
      accessorKey: "Cooking End Time",
    },
    {
      header: "Time Taken",
      accessorKey: "Time Taken",
    },
    
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
    },
  ]);


  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Kitchen Performance Report"}
        buttonDataa={buttonDataa}
     
      />
    </main>
  );
}

export default KitchenPerformanceReport;
